import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useAuthentication } from "hooks";
import { notificationService } from "services";

const NotificationContext = createContext();

export const useNotificationsContext = () => {
 const context = useContext(NotificationContext);
 if (!context) {
  throw new Error("useNotifications must be used within NotificationProvider");
 }
 return context;
};

export const NotificationProvider = ({ children }) => {
 const { user } = useAuthentication();
 const [notifications, setNotifications] = useState([]);
 const [unreadCount, setUnreadCount] = useState(0);
 const prevNotificationIdsRef = useRef(new Set());


 const TARGET = "customer";

 useEffect(() => {
  if (!user?.uid) return;

  const unsubscribe = notificationService.subscribe(user.uid, TARGET, (notifs) => {
    setNotifications(notifs);
    setUnreadCount(notifs.filter((n) => !n.read).length);

    prevNotificationIdsRef.current = new Set(notifs.map((n) => n.id));
   });

  return () => unsubscribe();
 }, [user?.uid]);

 const markAsRead = async (notificationId) => {
  await notificationService.markAsRead(notificationId);
 };

 const markAllAsRead = async () => {
  if (!user?.uid) return;
  await notificationService.markAllAsRead(user.uid, TARGET);
 };

 const clearNotification = async (notificationId) => {
  await notificationService.clear(notificationId);
 };

 const clearAllNotifications = async () => {
  if (!user?.uid) return;
  await notificationService.clearAll(user.uid, TARGET);
 };

 const value = {
  notifications,
  unreadCount,
  markAsRead,
  markAllAsRead,
  clearNotification,
  clearAllNotifications,
 };

 return (
  <NotificationContext.Provider value={value}>
   {children}
  </NotificationContext.Provider>
 );
};
